module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"welcome":"GALAXY CRUISEへようこそ！","do_not_show_again":"次回から表示しない","video_url":"https://www.youtube-nocookie.com/embed/Bi_mjT7tXk8?loop=1&playlist=Bi_mjT7tXk8"},"en":{"welcome":"Welcome to GALAXY CRUISE!","do_not_show_again":"Do not show again","video_url":"https://www.youtube-nocookie.com/embed/x8zF9UKhjzc?loop=1&playlist=Bi_mjT7tXk8"}}')
  delete Component.options._Ctor
}
